export default "__VITE_ASSET__BiVjMGiW__"